"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeployModelSubspace = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var TagHelpers_1 = require("../Tag/TagHelpers");
var TestIds_1 = require("../util/TestIds");
var DeployModelSubspace = function (props) {
    var _a = React.useState({ deployedModelId: '' }), deployedModelContext = _a[0], setDeployedModelContext = _a[1];
    var callDeployModel = function () {
        TagHelpers_1.DeployModel({
            storyId: props.predictiveModelContent.storyId,
            runId: props.predictiveModelContent.runId,
        }).then(function (response) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (response.deployedModelId !== undefined) {
                setDeployedModelContext({ deployedModelId: response.deployedModelId });
            }
        }, function (reason) {
            console.log(reason);
        });
    };
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", null,
                React.createElement("b", null, props.subspaceTitle))),
        React.createElement(widgets_1.ButtonWidget, { onClick: callDeployModel, testId: TestIds_1.DEPLOY_BUTTON_TEST_ID, buttonType: widgets_1.ButtonType.Primary }, 'Deploy Model'),
        React.createElement("div", null, deployedModelContext.deployedModelId !== '' && (React.createElement("label", null,
            'Model-id ',
            " ",
            deployedModelContext.deployedModelId,
            " ",
            'deployed')))));
};
exports.DeployModelSubspace = DeployModelSubspace;
//# sourceMappingURL=DeployModelSubspace.js.map